import React from 'react'
import { makeStyles } from '@material-ui/core'
import Icon from '../../../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    borderBottom: '1px solid var(--color-ai-200, rgba(169,88,255,0.25))',
    fontSize: 'var(--text-size-sm)',
    fontWeight: 600,
    color: 'var(--color-ai-700, #6b21a8)',
    flexShrink: 0,
    gap: '6px'
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--padding-lg)',
    color: 'var(--color-neutral-400)',
    textAlign: 'center',
    gap: 'var(--gap-md)'
  },
  title: {
    fontSize: 'var(--text-size-md)',
    fontWeight: 600,
    color: 'var(--color-neutral-500)'
  },
  subtitle: {
    fontSize: 'var(--text-size-sm)',
    lineHeight: 1.5,
    maxWidth: '220px'
  }
}))

function DesignerPanel () {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Icon name='chat' customSize='14px' />
        Designer
      </div>
      <div className={classes.body}>
        <Icon name='chat' customSize='32px' />
        <div className={classes.title}>Skill Designer</div>
        <div className={classes.subtitle}>
          AI-assisted skill authoring coming soon. Use the settings and instructions panels to configure your skill.
        </div>
      </div>
    </div>
  )
}

export default DesignerPanel
